import { Image as CoreImage } from '@portals/core/src/components/Image/Image';
import { Images } from '@portals/core/src/components/Images/Images';
import Image from 'next/image';
import React from 'react';
import { JsonLd } from 'react-schemaorg';
import { ImageObject } from 'schema-dts';

import { ContentImagesInformative as ContentImagesInformativeModel } from '../../../models/index';

export const ContentImagesInformative: React.FC<ContentImagesInformativeModel> = ({
  __component,
  id,
  media,
}: ContentImagesInformativeModel) => {
  return (
    <Images aspectRatio={`${media[0].width}/${media[0].height}`} id={`${__component}.${id}`}>
      {media.map((element) => {
        return (
          <CoreImage key={element.id} caption={element.caption} extendedCaption={element.extendedCaption}>
            <Image
              src={element.url}
              width={media[0].width}
              height={media[0].height}
              title={element.title}
              alt={element.alternativeText ?? ''}
              style={{
                maxWidth: '100%',
                width: '100%',
                height: `${Math.round((media[0].height / media[0].width) * 100)}%`,
                display: 'block',
                backgroundColor: '#292929',
                lineHeight: '1.5',
                fontFamily: 'monospace',
                fontSize: '16px',
                color: 'white',
              }}
            />
            <JsonLd<ImageObject>
              item={{
                // eslint-disable-next-line @if6/fi-no-absolute-urls
                '@context': 'https://schema.org',
                '@type': 'ImageObject',
                contentUrl: element.url,
                name: element.alternativeText,
                caption: element.caption ? element.caption : null,
              }}
            />
          </CoreImage>
        );
      })}
    </Images>
  );
};
